import { createSelector } from 'reselect';
import { EmptyObject, EmptyArray } from '../../EmptyDefaults.js';
import { indexLenders } from './Api.js';

export const WISETACK = 'Wisetack';
const PENDING_STATUS = 'pending';
export const ENABLED_STATUS = 'enabled';
export const DECLINED_STATUS = 'declined';
const APPLICATION_SUBMITTED_STATUS = 'application_submitted';
const PENDING_STATUSES = [PENDING_STATUS, APPLICATION_SUBMITTED_STATUS];

const LENDERS_NAMESPACE = 'lenders';

const getLenders = createSelector(
  (state) => state[LENDERS_NAMESPACE],
  (lenders) => lenders || EmptyObject
);

const getLendersData = createSelector(getLenders, (lenders) => lenders.data || EmptyArray);

const getLender = (lenderName) =>
  createSelector(getLendersData, (lenders) => {
    return lenders.find((lender) => lender.lender_name === lenderName) || EmptyObject;
  });

const getLenderStatus = (lenderName) =>
  createSelector(getLender(lenderName), (lender) => lender.app_configuration_status || '');

export const getPendingLoanAmount = (lenderName) =>
  createSelector(getLender(lenderName), (lender) => lender.pending_loan_amount || 0);

export const getLenderUsePendingLanguage = (lenderName) =>
  createSelector(getLender(lenderName), (lender) => lender.use_pending_language || false);

export const shouldShowApplicationSubmittedBanner = (lenderName) =>
  createSelector(getLenderStatus(lenderName), getPendingLoanAmount(lenderName), (lenderStatus, pendingLoanAmount) => {
    return lenderStatus === APPLICATION_SUBMITTED_STATUS && pendingLoanAmount > 0;
  });

export const shouldInviteToLenderApplication = (lenderName) =>
  createSelector(getLenderStatus(lenderName), getPendingLoanAmount(lenderName), (lenderStatus, pendingLoanAmount) => {
    return PENDING_STATUSES.includes(lenderStatus) && pendingLoanAmount > 0;
  });

export const fetchLenders = (lenderNames) => ({
  fetchingApiFunc: indexLenders,
  selector: getLendersData,
  paramsFromProps: () => [{ lender_names: lenderNames }],
  dataNamespace: LENDERS_NAMESPACE,
});
